import { Images } from "assets";
import classNames from "classnames";
import Separator from "shared/components/common/separater";
import styles from "./style.module.scss";

const FeaturesSection = () => {
  return (
    <section className={classNames("relative")}>
      <div className={classNames(styles.mainCont)}>
        <div className={classNames(styles.customContainer, "relative")}>
          <div
            className={classNames(styles.detailsCont, "flex-col md:flex-row")}
          >
            <h1 className={classNames(styles.title)}>
              <span>Powerful Features</span> for Seamless Job Evaluation
            </h1>
            <p className={classNames(styles.description, "md:self-end")}>
              RAStrack is meticulously crafted to transform the job
              evaluation process with a suite of powerful features. Experience
              the convenience of our user-friendly system. 
            </p>
          </div>
          <div
            className={classNames("flex flex-col md:flex-row  gap-10 mt-10")}
          >
            <div className={classNames(styles.feaatureContainer, "gap-8")}>
              <h2>Key Features</h2>
              <Separator />
              <h3>Additional Key Features:</h3>
              <div
                className={classNames("flex flex-col h-full justify-evenly")}
              >
                <img src={Images.FeatureAsset2} alt="" />
              </div>
            </div>
            <div className={classNames(styles.imgContainer)}>
              <img src={Images.FeatureAsset1} alt="" />
            </div>
          </div>
        </div>
      </div>
      <div className={classNames(styles.leftYellowContainer)} />
      <div className={classNames(styles.rightYellowContainer)} />
    </section>
  );
};

export default FeaturesSection;
